export class ScreenUtil {
  renderOnTop(): void {
    window.scrollTo({
      top: 0,
    });
  };

  regnoValidation(regno: string): boolean | string {
    if (regno === undefined) {
      // return "Matični broj nije ispravan!"
    }
    let A = parseInt(regno[0]);
    let B = parseInt(regno[1]);
    let V = parseInt(regno[2]);
    let G = parseInt(regno[3]);
    let D = parseInt(regno[4]);
    let X = parseInt(regno[5]);
    let E = parseInt(regno[6]);
    let Y = parseInt(regno[7]);
    let Z = parseInt(regno[8]);
    let I = parseInt(regno[9]);
    let J = parseInt(regno[10]);
    let K = parseInt(regno[11]);
    let L = parseInt(regno[12]);
    let CTRL = 11 - ((7 * (A + E) + 6 * (B + Y) + 5 * (V + Z) + 4 * (G + I) + 3 * (D + J) + 2 * (X + K)) % 11);
    console.log(CTRL);
    if (L === CTRL) {
      return false
    } else if (CTRL > 9 && L === 0) {
      return false
    } else {
      return 'JMBG nije ispravan'
    }
    /*let mainNumber=( 7*A + 6*B + 5*V + 4*G + 3*D + 2*X + 7*E + 6*Y * 5*Z + 4*I +3*J + 2*K ) % 11;
    console.log(mainNumber);
    mainNumber=11-mainNumber;
    console.log(mainNumber);
    if(mainNumber>=1 && mainNumber<11 && mainNumber===L){
      console.log(mainNumber);
      return false
    }
    let control =0;
    if (mainNumber>9 && L === control){
      console.log(mainNumber)
      return false
    }else{
      return "Matični broj nije ispravan!"
    }*/
  }

  emailValidation(email: string): boolean | string {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (re.test(String(email).toLowerCase())) {
      console.log(re.test(String(email).toLowerCase()));
      return false
    } else {
      return "E-mail nije u ispravnom formatu"
    }
  }
}
